import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { TitledTab } from 'portcall/pctabstrip/model';

import {
    BerthAssignmentDetails,
    TabActions,
    TabInPortOps
} from './model';

import {
    CoordinationCardDetailsCloseLink,
    CoordinationCardDetailsLoadingIcon
} from 'portcall/coordinationcarddetails/view';
import {
    PCTabContents,
    PCTabStripView,
    TitledTabContentsController,
    TitledTabStripViewController
} from 'portcall/pctabstrip/view';

import { BerthAssignmentDetailsActionsTabView as ActionsTabView } from './actionsview';
import { BerthAssignmentDetailsInPortOpsTabView as InPortOpsTabView } from './inportopsview';

export const BerthAssignmentDetailsView = SuperCritical(({ model: m } : { model : BerthAssignmentDetails }) =>
    <div className="berthassignmentdetails">
        <PCTabStripView
            model={m.TabStrip}
            ctrl={new TitledTabStripViewController()}
            extraContents={() =>
                <CoordinationCardDetailsCloseLink dismissDetails={m.DismissDetails} />
            }
        />
        <PCTabContents
            model={m.TabStrip}
            ctrl={new TabContentsController(m)}
        />
        <CoordinationCardDetailsLoadingIcon loading={m.Loading} />
    </div>
);

class TabContentsController extends TitledTabContentsController {
    constructor(readonly model : BerthAssignmentDetails) { super(); }

    renderTabContents(tab : TitledTab) {
        const m = this.model;
        if      (tab === TabActions  ) return <ActionsTabView model={m.ActionsTab} />;
        else if (tab === TabInPortOps) return <InPortOpsTabView model={m.InPortOpsTab} />;
        else throw new Error(`Unknown tab with title '${tab.Title}'`);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/view.tsx